import React, {useState} from 'react';
import {Timeline, TimelineEvent} from 'react-event-timeline'
import styles from '../styles/bio.scss';
import {SuitcaseIcon} from "./svg/SuitcaseIcon";
import {StudiesIcon} from "./svg/StudiesIcon";
import {BioOption} from "./bio/BioOption";
import {HandshakeIcon} from "./svg/HandshakeIcon";
import {Python} from "./svg/tech_icons/Python";
import {IconTextContainer} from "./portfolio/IconTextContainer";
import {BioDescription} from "./bio/BioDescription";
import {FastAPI} from "./svg/tech_icons/FastAPI";
import {DynamoDB} from "./svg/tech_icons/DynamoDB";
import {Database} from "./svg/tech_icons/Database";
import {AwsApiGateway} from "./svg/tech_icons/AwsApiGateway";
import {AwsGeneric} from "./svg/tech_icons/AwsGeneric";
import {Docker} from "./svg/tech_icons/Docker";
import {ReactIcon} from "./svg/tech_icons/ReactIcon";
import {Webpack} from "./svg/tech_icons/Webpack";
import {Acceleo} from "./svg/tech_icons/Acceleo";
import {Flask} from "./svg/tech_icons/Flask";
import {EMF} from "./svg/tech_icons/EMF";
import {D3JS} from "./svg/tech_icons/D3JS";
import {XML} from "./svg/tech_icons/XML";
import {Mobx} from "./svg/tech_icons/Mobx";
import {Sass} from "./svg/tech_icons/Sass";
import {Html} from "./svg/tech_icons/Html";
import {WordPress} from "./svg/tech_icons/WordPress";
import {Php} from "./svg/tech_icons/Php";
import {Django} from "./svg/tech_icons/Django";
import {PostgreSQL} from "./svg/tech_icons/PostgreSQL";
import {Redux} from "./svg/tech_icons/Redux";
import {MongoDB} from "./svg/tech_icons/MongoDB";
import {Spark} from "./svg/tech_icons/Spark";
import {ELB} from "./svg/tech_icons/aws/ELB";
import {NLB} from "./svg/tech_icons/aws/NLB";
import {S3} from "./svg/tech_icons/S3";
import {CloudFront} from "./svg/tech_icons/CloudFront";
import {Lambda} from "./svg/tech_icons/aws/Lambda";
import {VPC} from "./svg/tech_icons/aws/VPC";
import {SQS} from "./svg/tech_icons/aws/SQS";
import {IAM} from "./svg/tech_icons/aws/IAM";
import {SNS} from "./svg/tech_icons/aws/SNS";
import {ECS} from "./svg/tech_icons/aws/ECS";
import {EC2} from "./svg/tech_icons/aws/EC2";
import {Cognito} from "./svg/tech_icons/aws/Cognito";
import {Cloudformation} from "./svg/tech_icons/aws/Cloudformation";
import {Athena} from "./svg/tech_icons/aws/Athena";
import {Javascript} from "./svg/tech_icons/Javascript";
import {Kafka} from "./svg/tech_icons/Kafka";
import {RabbitMQ} from "./svg/tech_icons/RabbitMQ";
import {Ansible} from "./svg/tech_icons/Ansible";
import {Terraform} from "./svg/tech_icons/Terraform";


export const Bio = props => {
    const [educationIsActive, setEducationStatus] = useState(true);
    const [experienceIsActive, setExperienceStatus] = useState(true);
    const [freelanceIsActive, setFreelanceStatus] = useState(true);

    return (
        <div className={styles.bioContainer}>
            <div className={styles.optionsContainer}>
                <BioOption
                    text={"Education"}
                    active={educationIsActive}
                    IconComp={StudiesIcon}
                    onClick={() => setEducationStatus(!educationIsActive)}
                />
                <BioOption
                    text={"Working Experience"}
                    active={experienceIsActive}
                    IconComp={SuitcaseIcon}
                    onClick={() => setExperienceStatus(!experienceIsActive)}
                />
                <BioOption
                    text={"Freelancing Experience"}
                    active={freelanceIsActive}
                    IconComp={HandshakeIcon}
                    onClick={() => setFreelanceStatus(!freelanceIsActive)}
                />
            </div>

            <div className={styles.timelineContainer}>
                <Timeline>
                    {
                        experienceIsActive
                            ?
                            <TimelineEvent
                                title={<div className={styles.titleStyle}>Cloud Engineer</div>}
                                subtitle={<div className={styles.subTitleStyle}>Net2Grid (Thessaloniki)</div>}
                                createdAt={<div className={styles.dateStyle}>2020 Jul - Present</div>}
                                icon={<SuitcaseIcon className={styles.iconStyle}/>}
                                bubbleStyle={{border: 'none',}}
                                style={{overflowX: 'hidden',}}
                            >
                                <BioDescription
                                    bullets={[
                                        'Managed and extended the company’s AWS infrastructure, including VPCs, IAM, NLB,' +
                                        ' ELB with Auto Scaling Groups (ASG), Kinesis, Lambda, API Gateway,' +
                                        ' EC2, ECS, Fargate, S3, SQS, SNS, CloudFront, RDS, DynamoDB, Athena, Glue, using Troposphere and Terraform.',
                                        'Implemented highly available, low latency, high throughput (1,000 QPS, more than 20MB per second), ' +
                                        'and cost-efficient serverless microservices for ensuring  at least 99% availability of several platforms with more than 10,000 users.',
                                        'Improved product quality by increasing test coverage by more than 50%,' +
                                        ' introduced new frameworks and tools (FastAPI, dependency-injector), and participated in the refinement of documentation procedures.',
                                        'Refactored core services in order to support the Oauth 2.0 protocol (Authorization Code Grant), using AWS Cognito.',
                                        'Involved in time-critical projects that enabled the successful enrollment of 3 of the biggest energy suppliers in the EU.',
                                        'On-boarded new team members.',
                                    ]}
                                    iconComponentList={[
                                        <IconTextContainer
                                            text={'Elastic Load Balancer'}
                                            IconComp={ELB}
                                            key={'bio-elb'}
                                            extraStyle={styles.bioTechIcon}
                                            // onClick={() => {window.open('', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'Network Load Balancer'}
                                            IconComp={NLB}
                                            key={'bio-nlb'}
                                            extraStyle={styles.bioTechIcon}
                                            // onClick={() => {window.open('', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'S3'}
                                            IconComp={S3}
                                            key={'bio-s3'}
                                            // onClick={() => {window.open('', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'API Gateway'}
                                            IconComp={AwsApiGateway}
                                            key={'bio-apigateway-icon'}
                                            // onClick={() => {window.open('', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'Lambda'}
                                            IconComp={Lambda}
                                            key={'bio-awslambda-icon'}
                                            // onClick={() => {window.open('', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'Cloudfront Distribution'}
                                            IconComp={CloudFront}
                                            key={'bio-cloudfront-icon'}
                                            // onClick={() => {window.open('', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'VPC'}
                                            IconComp={VPC}
                                            key={'bio-vpc-icon'}
                                            // onClick={() => {window.open('', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'SQS'}
                                            IconComp={SQS}
                                            key={'bio-SQS-icon'}
                                            // onClick={() => {window.open('', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'SNS'}
                                            IconComp={SNS}
                                            key={'bio-SNS-icon'}
                                            // onClick={() => {window.open('', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'IAM'}
                                            IconComp={IAM}
                                            key={'bio-IAM-icon'}
                                            // onClick={() => {window.open('', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'ECS'}
                                            IconComp={ECS}
                                            key={'bio-ECS-icon'}
                                            // onClick={() => {window.open('', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'EC2'}
                                            IconComp={EC2}
                                            key={'bio-EC2-icon'}
                                            // onClick={() => {window.open('', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'Cognito'}
                                            IconComp={Cognito}
                                            key={'bio-Cognito-icon'}
                                            // onClick={() => {window.open('', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'Cloudformation'}
                                            IconComp={Cloudformation}
                                            key={'bio-Cloudformation-icon'}
                                            // onClick={() => {window.open('', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'Athena'}
                                            IconComp={Athena}
                                            key={'bio-Athena-icon'}
                                            // onClick={() => {window.open('', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'Python'}
                                            IconComp={Python}
                                            key={'bio-py'}
                                        />,
                                        <IconTextContainer
                                            text={'Javascript'}
                                            IconComp={Javascript}
                                            key={'bio-Javascript'}
                                        />,
                                        <IconTextContainer
                                            text={'PHP'}
                                            IconComp={Php}
                                            key={'bio-php'}
                                        />,
                                        <IconTextContainer text={'Docker'} IconComp={Docker} key={'bio-docker'}/>,
                                        <IconTextContainer text={'Kafka'} IconComp={Kafka} key={'bio-kafka-icon'}/>,
                                        <IconTextContainer text={'RabbitMQ'} IconComp={RabbitMQ} key={'bio-kafka-icon'}/>,
                                        <IconTextContainer text={'FastAPI'} IconComp={FastAPI} key={'bio-fastapi-icon'}/>,
                                        <IconTextContainer text={'DynamoDB'} IconComp={DynamoDB} key={'bio-ddb-icon'}/>,
                                        <IconTextContainer
                                            text={'Ansible'}
                                            IconComp={Ansible}
                                            key={'bio-Javascript'}
                                        />,
                                        <IconTextContainer
                                            text={'Terraform'}
                                            IconComp={Terraform}
                                            key={'bio-Terraform'}
                                        />,
                                    ]}
                                />
                            </TimelineEvent>
                            :
                            <div/>
                    }

                    {
                        experienceIsActive
                            ?
                            <TimelineEvent
                                title={<div className={styles.titleStyle}>Backend Engineer</div>}
                                subtitle={<div className={styles.subTitleStyle}>Research & Informatics Corps, Hellenic
                                    Army (Alexandroupoli)</div>}
                                createdAt={<div className={styles.dateStyle}>August 2019 - May 2020</div>}
                                icon={<SuitcaseIcon className={styles.iconStyle}/>}
                                bubbleStyle={{border: 'none',}}
                                style={{overflowX: 'hidden',}}
                            >
                                <BioDescription
                                    bullets={[
                                        'Worked as a Backend Engineer (during mandatory military service) in an Agile team ' +
                                        'of 5 engineers that maintained several microservices, using MongoDB, ApacheSpark, ' +
                                        'Laravel, Flask, Python, PHP, Docker, and Kubernetes.',
                                        'Developed a microservice for collecting several metrics (network traffic, USB ' +
                                        'connections, file events, etc) from computers of a private network, and storing them into a MongoDB cluster.',
                                        'Implemented ETL pipeline with Apache Spark for processing of the above metrics by various ML models.',
                                        'Improved containerization and automation tools resulting in at least 30% reduction of the development time.'
                                    ]}
                                    iconComponentList={[
                                        <IconTextContainer
                                            text={'MongoDB'}
                                            IconComp={MongoDB}
                                            key={'bio-MongoDB'}
                                            extraStyle={styles.bioTechIcon}
                                            onClick={() => {window.open('https://www.mongodb.com/', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'ApacheSpark'}
                                            IconComp={Spark}
                                            key={'bio-Spark'}
                                            extraStyle={styles.bioTechIcon}
                                            onClick={() => {window.open('https://spark.apache.org/', '_blank');}}
                                        />,
                                        <IconTextContainer text={'Docker'} IconComp={Docker} key={'bio-docker'}/>,
                                        <IconTextContainer
                                            text={'Flask'}
                                            IconComp={Flask}
                                            key={'bio-flask'}
                                            extraStyle={styles.bioTechIcon}
                                            onClick={() => {window.open('https://flask.palletsprojects.com/en/2.2.x/', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'Python'}
                                            IconComp={Python}
                                            key={'bio-py'}
                                            extraStyle={styles.bioTechIcon}
                                        />,
                                        <IconTextContainer
                                            text={'PHP'}
                                            IconComp={Php}
                                            key={'bio-php'}
                                            extraStyle={styles.bioTechIcon}
                                        />,
                                    ]}
                                />
                            </TimelineEvent>
                            :
                            <div/>
                    }

                    {
                        freelanceIsActive
                            ?
                            <TimelineEvent
                                title={<div className={styles.titleStyle}>Freelance Full Stack Developer</div>}
                                subtitle={<div className={styles.subTitleStyle}>Athens (Remote)</div>}
                                createdAt={<div className={styles.dateStyle}>January 2017 - July 2019</div>}
                                icon={<HandshakeIcon className={styles.iconStyle}/>}
                                bubbleStyle={{border: 'none',}}
                                style={{overflowX: 'hidden',}}
                            >
                                <BioDescription
                                    bullets={[
                                        'Participated in an Agile team of 7 engineers for the implementation, and maintenance of an Electronic Patient Record, used by multiple private healthcare organizations.',
                                        'Developed microservices built with Django-REST,  and PostgreSQL.',
                                        'Maintained User Interface built with React and Redux.'
                                    ]}
                                    iconComponentList={[
                                        <IconTextContainer
                                            text={'Django'}
                                            IconComp={Django}
                                            key={'bio-django'}
                                            extraStyle={styles.bioTechIcon}
                                            onClick={() => {window.open('https://www.djangoproject.com/', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'PostgreSQL'}
                                            IconComp={PostgreSQL}
                                            key={'bio-PostgreSQL'}
                                            extraStyle={styles.bioTechIcon}
                                            onClick={() => {window.open('https://www.postgresql.org/', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'ReactJS'}
                                            IconComp={ReactIcon}
                                            key={'bio-react'}
                                            onClick={() => {window.open('https://reactjs.org/', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'Redux'}
                                            IconComp={Redux}
                                            key={'bio-Redux'}
                                            onClick={() => {window.open('https://redux.js.org/', '_blank');}}
                                        />,
                                        <IconTextContainer text={'Docker'} IconComp={Docker} key={'bio-docker'}/>,
                                        <IconTextContainer text={'DockerCompose'} IconComp={Docker} key={'bio-dockerCompose'}/>,
                                    ]}
                                />
                            </TimelineEvent>
                            :
                            <div/>
                    }

                    {
                        freelanceIsActive
                            ?
                            <TimelineEvent
                                title={<div className={styles.titleStyle}>Freelance Frontend Developer</div>}
                                subtitle={<div className={styles.subTitleStyle}>Thessaloniki</div>}
                                createdAt={<div className={styles.dateStyle}>December 2015 - August 2017</div>}
                                icon={<HandshakeIcon className={styles.iconStyle}/>}
                                bubbleStyle={{border: 'none',}}
                                style={{overflowX: 'hidden',}}
                            >
                                <BioDescription
                                    bullets={[
                                        'Designed, implemented, deployed, and maintained personal websites using React, Webpack, HTML, SCSS.',
                                        'Maintained the eshop of a local agriculture company, using WordPress and PHP.',
                                        'Participated in the requirements analysis, design, ' +
                                        'implementation and maintenance of an in-house operations management software used by a private learning center.'
                                    ]}
                                    iconComponentList={[
                                        <IconTextContainer
                                            text={'HTML'}
                                            IconComp={Html}
                                            key={'bio-html'}
                                            extraStyle={styles.bioTechIcon}
                                        />,
                                        <IconTextContainer
                                            text={'SCSS'}
                                            IconComp={Sass}
                                            key={'bio-scss'}
                                            extraStyle={styles.bioTechIcon}
                                            onClick={() => {window.open('https://sass-lang.com/', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'ReactJS'}
                                            IconComp={ReactIcon}
                                            key={'bio-react'}
                                            onClick={() => {window.open('https://reactjs.org/', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'Webpack'}
                                            IconComp={Webpack}
                                            key={'bio-webpack'}
                                            extraStyle={styles.bioTechIcon}
                                            onClick={() => {window.open('https://webpack.js.org/', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'Mobx'}
                                            IconComp={Mobx}
                                            key={'bio-Mobx'}
                                            extraStyle={styles.bioTechIcon}
                                            onClick={() => {window.open('https://mobx.js.org/', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'WordPress'}
                                            IconComp={WordPress}
                                            key={'bio-wordpress'}
                                            extraStyle={styles.bioTechIcon}
                                        />,
                                        <IconTextContainer
                                            text={'Flask'}
                                            IconComp={Flask}
                                            key={'bio-flask'}
                                            extraStyle={styles.bioTechIcon}
                                            onClick={() => {window.open('https://flask.palletsprojects.com/en/2.2.x/', '_blank');}}
                                        />,
                                        <IconTextContainer
                                            text={'Python'}
                                            IconComp={Python}
                                            key={'bio-py'}
                                            extraStyle={styles.bioTechIcon}
                                        />,
                                        <IconTextContainer
                                            text={'PHP'}
                                            IconComp={Php}
                                            key={'bio-php'}
                                            extraStyle={styles.bioTechIcon}
                                        />,
                                        <IconTextContainer
                                            text={'D3JS'}
                                            IconComp={D3JS}
                                            key={'bio-d3js'}
                                            extraStyle={styles.bioTechIcon}
                                            onClick={() => {window.open('https://d3js.org/', '_blank');}}
                                        />,
                                    ]}
                                />
                            </TimelineEvent>
                            :
                            <div/>
                    }

                    {
                        educationIsActive
                            ?
                            <TimelineEvent
                                title={<div className={styles.titleStyle}>M.Eng. Electrical & Computer Engineering</div>}
                                subtitle={<div className={styles.subTitleStyle}>Aristotle University Of Thessaloniki</div>}
                                createdAt={<div className={styles.dateStyle}>October 2013 - May 2019</div>}
                                icon={<StudiesIcon className={styles.iconStyle}/>}
                                bubbleStyle={{border: 'none',}}
                                style={{overflowX: 'hidden',}}
                            >
                                <BioDescription
                                    text={'Master Thesis on Software Automation based on Model Driven Engineering: ' +
                                    'Design of a Model-Driven mechanism to automate graphical Web-UI generation' +
                                    ' for domain specific application modelling.'}
                                    // iconComponentList={[
                                    //     <IconTextContainer
                                    //         text={'Python'}
                                    //         IconComp={Python}
                                    //         key={'bio-py'}
                                    //         extraStyle={styles.bioTechIcon}
                                    //     />,
                                    //     <IconTextContainer
                                    //         text={'Flask'}
                                    //         IconComp={Flask}
                                    //         key={'bio-flask'}
                                    //         extraStyle={styles.bioTechIcon}
                                    //         onClick={() => {window.open('https://flask.palletsprojects.com/en/2.2.x/', '_blank');}}
                                    //     />,
                                    //     <IconTextContainer
                                    //         text={'ReactJS'}
                                    //         IconComp={ReactIcon}
                                    //         key={'bio-react'}
                                    //         onClick={() => {window.open('https://reactjs.org/', '_blank');}}
                                    //     />,
                                    //     <IconTextContainer
                                    //         text={'D3JS'}
                                    //         IconComp={D3JS}
                                    //         key={'bio-d3js'}
                                    //         extraStyle={styles.bioTechIcon}
                                    //         onClick={() => {window.open('https://d3js.org/', '_blank');}}
                                    //     />,
                                    //     <IconTextContainer
                                    //         text={'Mobx'}
                                    //         IconComp={Mobx}
                                    //         key={'bio-Mobx'}
                                    //         extraStyle={styles.bioTechIcon}
                                    //         onClick={() => {window.open('https://mobx.js.org/', '_blank');}}
                                    //     />,
                                    //     <IconTextContainer
                                    //         text={'PyEcore'}
                                    //         IconComp={Python}
                                    //         key={'bio-PyEcore'} extraStyle={styles.bioTechIcon}
                                    //         onClick={() => {window.open('https://github.com/pyecore/pyecore', '_blank');}}
                                    //     />,
                                    //     <IconTextContainer
                                    //         text={'Ecore'}
                                    //         IconComp={EMF}
                                    //         key={'bio-Ecore'}
                                    //         extraStyle={styles.bioTechIcon}
                                    //         onClick={() => {window.open('https://www.eclipse.org/modeling/emf/', '_blank');}}
                                    //     />,
                                    //     <IconTextContainer
                                    //         text={'Acceleo'}
                                    //         IconComp={Acceleo}
                                    //         key={'bio-Acceleo'} extraStyle={styles.bioTechIcon}
                                    //         onClick={() => {window.open('https://www.eclipse.org/acceleo/', '_blank');}}
                                    //     />,
                                    //     <IconTextContainer
                                    //         text={'XML'}
                                    //         IconComp={XML}
                                    //         key={'bio-xml'}
                                    //         extraStyle={styles.bioTechIcon}
                                    //     />,
                                    // ]}
                                />

                            </TimelineEvent>
                            :
                            <div/>
                    }

                </Timeline>
            </div>
        </div>
    )
};
